// Native
import { useState } from "react"

// Components
import { Button, ButtonGroup, ModalBody, ModalFooter, useToast } from "@chakra-ui/react"
import { Form, Icon, Modal } from "components"

// Config
import { API } from "config"

export default function Publish({ data, model = 'orders', options = {}, onSuccess = () => {}, ...props }){
    
    const toast = useToast()
    const [ form, setForm ] = useState({})
    const [ loading, setLoading ] = useState(false)
    const [ errors, setErrors ] = useState(false)

    const maxlength = 240
    const enabled = form?.body?.length >= 3

    const onChange = ({ target }) => {
        const { name, value } = target

        switch(name){
            case 'body': if(value.length <= maxlength) setForm({...form, [name]: value}); break;
            default: setForm({...form, [name]: value}); break;
        }
        
    }

    const handleSubmit = async () => {
        setLoading(true)
        setErrors(false)

        try{
            await API.post(`/${model}/${data.id}/comments`, {...form, ...options})
            toast({ title: 'O comentário foi publicado', status: 'success' })
            setForm({})
            onSuccess()
            props.onClose()
        }catch(err){
            setErrors(err?.response?.data?.errors)
            toast({ title: 'Não foi possível publicar o comentário', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    return(
    <Modal title="Publicar comentário" loading={loading} {...props}>
        <ModalBody>
            <Form.Form onSubmit={handleSubmit}>

                <Form.Textarea 
                    required
                    label="Escreva seu comentário:"
                    name="body"
                    value={form?.body}
                    error={errors?.body}
                    helper={`Você possui ${maxlength -( form?.body?.length ?? 0)} caracteres restantes.`}
                    onChange={onChange}
                    isDisabled={loading}
                />

            </Form.Form>
        </ModalBody>
        <ModalFooter>
            <ButtonGroup size="sm" isDisabled={loading}>
                <Button children="Publicar" leftIcon={<Icon name="comment" />} isLoading={loading} isDisabled={!enabled} onClick={handleSubmit} />
                <Button children="Cancelar" colorScheme="red" onClick={props.onClose} />
            </ButtonGroup>
        </ModalFooter>
    </Modal>
    )
}